import {useEffect, useMemo, useState} from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

export const useCountdown = (totalSeconds, timeout = 1000) => {
  const [secondsLeft, setSecondsLeft] = useState(totalSeconds);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (totalSeconds && secondsLeft != totalSeconds) {
      setSecondsLeft(totalSeconds);
    }
  }, [totalSeconds]);

  useEffect(() => {
    let interval;
    if (isActive && secondsLeft > 0) {
      interval = setTimeout(() => setSecondsLeft(secondsLeft - timeout / 1000), timeout);
    }

    return () => interval && clearTimeout(interval);
  }, [totalSeconds, secondsLeft, isActive, timeout]);

  const activateCountdown = () => setIsActive(true);
  const resetCountdown = () => setSecondsLeft(totalSeconds);

  const diffTimeDelta = useMemo(() => dayjs().add(secondsLeft, "second").diff(dayjs()) || 0, [secondsLeft]);
  const duration = useMemo(() => dayjs.duration(diffTimeDelta), [diffTimeDelta]);
  const daysRemaining = useMemo(() => (totalSeconds <= 0 ? 0 : Math.abs(duration.days())), [totalSeconds, duration]);
  const hoursRemaining = useMemo(() => (totalSeconds <= 0 ? 0 : Math.abs(duration.hours())), [totalSeconds, duration]);
  const minutesRemaining = useMemo(
    () => (totalSeconds <= 0 ? 0 : Math.abs(duration.minutes())),
    [totalSeconds, duration],
  );
  const secondsRemaining = useMemo(
    () => (totalSeconds <= 0 ? 0 : Math.abs(duration.seconds())),
    [totalSeconds, duration],
  );

  return {daysRemaining, hoursRemaining, minutesRemaining, secondsRemaining, activateCountdown, resetCountdown};
};
